export default __webpack_public_path__ + "static/media/icon-door-lock.73c59a84.svg";